module.exports = __webpack_public_path__ + "img/rewise-logo-powered.7d987d12.png";